import { Phone, Mail, MapPin } from "lucide-react";

const Header = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      {/* Top bar */}
      <div className="bg-gradient-to-r from-slate-800 to-slate-700 text-white py-1.5">
        <div className="container mx-auto px-4 flex flex-wrap justify-between items-center text-sm">
          <div className="flex items-center gap-4">
            <a href="mailto:chaitraenterprisesbsk@gmail.com" className="flex items-center gap-2 hover:text-amber-400 transition-colors">
              <Mail size={14} />
              <span className="text-xs md:text-sm">chaitraenterprisesbsk@gmail.com</span>
            </a>
          </div>
          <div className="flex items-center gap-2">
            <MapPin size={14} />
            <span className="text-xs">Banashankari, Bengaluru</span>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="container mx-auto px-4 py-2">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_chaitra-property-reg/artifacts/bd0963e6_ChatGPT%20Image%20Mar%201%2C%202026%2C%2011_14_27%20PM.png" 
              alt="Chaitra Enterprises Logo" 
              className="h-14 md:h-20 w-auto object-contain"
            />
          </div>
          
          <div className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection("about")} className="text-slate-700 hover:text-emerald-700 font-medium transition-colors">
              About
            </button>
            <button onClick={() => scrollToSection("services")} className="text-slate-700 hover:text-emerald-700 font-medium transition-colors">
              Services
            </button>
            <button onClick={() => scrollToSection("process")} className="text-slate-700 hover:text-emerald-700 font-medium transition-colors">
              Process
            </button>
            <button onClick={() => scrollToSection("faq")} className="text-slate-700 hover:text-emerald-700 font-medium transition-colors">
              FAQ
            </button>
            <button onClick={() => scrollToSection("contact")} className="text-slate-700 hover:text-emerald-700 font-medium transition-colors">
              Contact
            </button>
          </div>

          <a 
            href="tel:+918217026707"
            className="bg-gradient-to-r from-emerald-700 to-emerald-600 text-white px-5 py-2 rounded-md font-semibold hover:from-emerald-800 hover:to-emerald-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm"
          >
            Call Now
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Header;
